import styled, { createGlobalStyle } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black6};

  .ant-select {
    width: 180px;
    border: 1px solid ${({ theme }) => theme.colors.black4};
    border-radius: 4px;
  }
`;

export const HideAntDefaultCheck = createGlobalStyle`
  .ant-select-dropdown {
    .ant-select-item-option-selected .ant-select-item-option-state {
      display: none !important;
    }
  }
`;

export const FilterOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FilterOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FilterOptionLabel = styled.span<{ $color?: string }>`
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ $color }) => $color || 'inherit'};
`;

export const FilterTagRenderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  padding: 2px 6px;
  margin: 2px;
`;
